import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import {
  DEFAULT_TENANT_PRESENTATION,
  PORTAL_STORAGE_KEYS,
  type SupportedPortalLocale,
} from '@heglo/ui/tokens';
import ar from './locales/ar.json';
import en from './locales/en.json';

function readStoredLanguage(storageKey: string): SupportedPortalLocale | null {
  try {
    const stored = localStorage.getItem(storageKey);
    if (!stored) return null;
    const language = JSON.parse(stored)?.state?.language;
    return language === 'ar' || language === 'en' ? language : null;
  } catch {
    return null;
  }
}

function getStoredLanguage(): SupportedPortalLocale {
  return readStoredLanguage(PORTAL_STORAGE_KEYS.uiSettings)
    || readStoredLanguage(PORTAL_STORAGE_KEYS.legacyUiSettings)
    || DEFAULT_TENANT_PRESENTATION.defaultLocale;
}

const initialLanguage = getStoredLanguage();
document.documentElement.dir = initialLanguage === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = initialLanguage;

void i18n.use(initReactI18next).init({
  resources: {
    ar: { translation: ar },
    en: { translation: en },
  },
  lng: initialLanguage,
  fallbackLng: DEFAULT_TENANT_PRESENTATION.defaultLocale,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
